// src/components/Hero.jsx

import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import fondo from "../assets/fondo1.jpg";

const Hero = () => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.18,
      },
    },
  };

  const item = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: "easeOut",
      },
    },
  };

  const buttons = [
    {
      title: "RESERVAS",
      description:
        "Tatuajes personalizados creados para fluir con tu cuerpo, historia y movimiento.",
      cta: "Entrar",
      path: "/reservas",
    },
    {
      title: "MENTORÍAS",
      description:
        "Método A.L.M.A\n\nEncontrá tu estilo · Aprendé a comunicarlo · Posicionate · Viví de tu arte",
      cta: "Descubrir",
      path: "/mentorias",
    },
    {
      title: "PRÓXIMOS DESTINOS",
      description: "Ciudades, fechas y disponibilidad.",
      cta: "Ver destinos",
      path: "/destinos",
    },
  ];

  return (
    <section
      className="
        relative
        min-h-screen
        w-full
        flex
        items-center
        justify-center
        overflow-hidden
        px-6
        py-24
      "
    >
      {/* BACKGROUND */}
      <img
        src={fondo}
        alt="Aldana Selena"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-[#0E0B09]/80 backdrop-blur-[2px]" />

      {/* CONTENT */}
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="
          relative
          z-10
          w-full
          max-w-[920px]
          flex
          flex-col
          items-center
          text-center
        "
      >
        {/* TITLE */}
        <motion.h1
          variants={item}
          className="
            uppercase
            text-[#C6A98A]
            font-extralight
            tracking-[0.32em]
            text-3xl
            sm:text-5xl
            md:text-6xl
            lg:text-7xl
          "
        >
          ALDANA SELENA
        </motion.h1>

        {/* SUBTITLE */}
        <motion.p
          variants={item}
          className="
            mt-6
            uppercase
            text-[#8C6F5A]
            tracking-[0.42em]
            text-[10px]
            sm:text-xs
            md:text-sm
          "
        >
          Tattoo Artist · Mentorías · Próximos destinos
        </motion.p>

        {/* PHRASE */}
        <motion.p
          variants={item}
          className="
            mt-12
            max-w-[720px]
            text-[#E8D8C3]
            font-light
            italic
            leading-relaxed
            text-sm
            sm:text-base
            md:text-xl
          "
        >
          “Arte creado para sentirse.
          <br />
          Identidad construida para trascender.”
        </motion.p>

        {/* DIVIDER */}
        <motion.div
          variants={item}
          className="w-20 h-px bg-[#8C6F5A]/40 my-14"
        />

        {/* BUTTON BLOCKS */}
        <motion.div
          variants={item}
          className="
            w-full
            grid
            grid-cols-1
            md:grid-cols-3
            gap-5
          "
        >
          {buttons.map((button, index) => (
            <Link
              key={index}
              to={button.path}
              className="
                group
                relative
                overflow-hidden
                min-h-[260px]
                border
                border-[#8C6F5A]/20
                bg-[#C6A98A]/[0.03]
                backdrop-blur-sm
                px-6
                py-8
                flex
                flex-col
                justify-between
                transition-all
                duration-500
                hover:border-[#C6A98A]/40
                hover:bg-[#C6A98A]/[0.06]
                hover:-translate-y-1
              "
            >
              {/* GLOW */}
              <div
                className="
                  absolute
                  inset-0
                  opacity-0
                  group-hover:opacity-100
                  transition-opacity
                  duration-500
                  bg-gradient-to-br
                  from-[#C6A98A]/5
                  via-transparent
                  to-transparent
                "
              />

              {/* TOP */}
              <div className="relative z-10">
                <div
                  className="
                    text-[#C6A98A]
                    uppercase
                    tracking-[0.28em]
                    font-light
                    text-sm
                    md:text-base
                  "
                >
                  {button.title}
                </div>

                <div
                  className="
                    mt-5
                    whitespace-pre-line
                    text-[#8C6F5A]
                    font-light
                    leading-relaxed
                    text-xs
                    sm:text-sm
                  "
                >
                  {button.description}
                </div>
              </div>

              {/* CTA */}
              <div
                className="
                  relative
                  z-10
                  mt-10
                  flex
                  items-center
                  gap-2
                  uppercase
                  text-[#C6A98A]
                  tracking-[0.24em]
                  text-[11px]
                  sm:text-xs
                  transition-all
                  duration-300
                  group-hover:gap-4
                "
              >
                <span>→</span>
                <span>{button.cta}</span>
              </div>
            </Link>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;